import React from 'react';
import { Button } from '@attentive-platform/stem-ui';

export default function SOPAddBar({
  addTradeValue,
  setAddTradeValue,
  addableTrades,
  onAddTrade,
  onOpenAddAllConfirm
}) {
  return (
    <div className='sop-add-trade-section'>
      <select
        value={addTradeValue}
        onChange={e => setAddTradeValue(e.target.value)}
        className='sop-add-trade-select'
        placeholder='Select Trade to Add'
      >
        <option value='' disabled>Select Trade to Add</option>
        {addableTrades.map(trade => (
          <option key={trade.trade_id} value={trade.trade_id}>{trade.trade_name}</option>
        ))}
      </select>
      <Button
        color='primary'
        variant='contained'
        onClick={onAddTrade}
        disabled={!addTradeValue}
        className='fw-semibold sop-add-trade-btn sop-add-trade-flex'
      >
        Add Trade
      </Button>
      <Button
        color='secondary'
        variant='contained'
        onClick={onOpenAddAllConfirm}
        className='fw-semibold sop-add-all-btn sop-add-trade-flex'
      >
        Add All Trades
      </Button>
    </div>
  );
} 